import { GA4Event } from '@/libs/ga4';
import { sendEvent } from '@/libs/ga4/functions/send-event';

export function ga4_signUp({
  user_id,
  method,
}: {
  user_id?: string;
  method?: string;
}) {
  sendEvent(
    GA4Event.SignUp,
    { items: undefined },
    {
      user_id,
      method,
    },
  );
}
